<div class="block-content" [style]="layoutService.blockContentStyle">
  <div [style]="layoutService.globalDimensionsStyle">
    <div
      class="min-h-screen flex relative surface-ground"
      [style.--sidebar-v2-width.px]="sidebarFlowWidthPx">
      <!-- Overlay mobile — fecha a sidebar ao clicar fora -->
      @if (!sidebarCollapsed && isMobile) {
        <div class="sidebar-overlay" (click)="toggleSidebar('mobile-overlay')"></div>
      }

      <!-- ── SIDEBAR V2 ─────────────────────────────────────────────── -->
      <div
        id="app-sidebar-v2"
        [ngClass]="{ hiddenNavBar: isExtendModeNav }"
        class="sidebar-v2 border-right-1 surface-border bg-primary h-screen flex-shrink-0 left-0 top-0 select-none"
        style="z-index: 1033 !important"
        [class.sidebar--collapsed]="sidebarCollapsed"
        #sidebar>
        <div class="sidebar-shell flex flex-column h-full">
          <!-- Logo + botão toggle (único, à direita do logo) -->
          <div
            class="sidebar-header flex align-items-center flex-shrink-0 border-right-1 surface-border shadow-3"
            [ngClass]="{
              'surface-50 border-right-1': (panelConfig$ | async)?.logo_url,
              'bg-primary border-right-0': !(panelConfig$ | async)?.logo_url,
            }"
            style="height: 64px; min-width: 0; padding: 0 8px 0 12px; gap: 6px; overflow: hidden">
            <!-- Logo ocupa o espaço disponível -->
            <div class="sidebar-logo-wrap">
              @if (loadingConfig) {
                <patron-spinner></patron-spinner>
              } @else {
                @if ((panelConfig$ | async)?.logo_url) {
                  <div class="logo">
                    <img [src]="(panelConfig$ | async)?.logo_url" [alt]="panelTitle" />
                  </div>
                } @else {
                  <img src="assets/logo-vendor.png" alt="Teorema Sistemas" width="36" />
                }
              }
            </div>
            <!-- Botão toggle à direita -->
            <button
              type="button"
              (click)="toggleSidebar('sidebar-header-button')"
              class="sidebar-toggle-btn"
              title="Fechar menu">
              <patron-icon name="bi-list"></patron-icon>
            </button>
          </div>

          <!-- PanelMenu scrollável -->
          <div class="sidebar-scroll flex-1">
            <p-panelMenu
              [model]="panelMenuItems"
              [multiple]="false"
              styleClass="sidebar-panel-menu w-full">
            </p-panelMenu>
          </div>

          <!-- Itens rodapé (position: bottom) -->
          @if (navItemsBottom.length) {
            <div class="sidebar-bottom-nav mt-auto flex-shrink-0">
              <hr class="mb-2 mx-2 border-top-1 border-none border-gray-600" />
              <ul class="list-none p-3 m-0">
                @for (navItem of navItemsBottom; track navItem) {
                  <li>
                    <a
                      [routerLink]="navItem.url"
                      [ngClass]="{ 'bg-primary2 text-white': isActiveNavItem(navItem) }"
                      class="flex align-items-center cursor-pointer text-decoration-none p-2 my-1 hover:bg-primary2 border-round text-gray-300 hover:text-white transition-duration-150 transition-colors">
                      @if (navItem?.icon) {
                        <patron-icon [name]="navItem.icon!" class="me-2"></patron-icon>
                      }
                      <span class="font-medium text-sm">{{ navItem?.name }}</span>
                      @if (navItem?.isBetaInNav) {
                        <patron-badge class="ms-auto" color="success">BETA</patron-badge>
                      }
                      @if (navItem?.isLegacyInNav) {
                        <patron-badge class="ms-auto" color="warning">ANTIGO</patron-badge>
                      }
                    </a>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      </div>
      <!-- ── FIM SIDEBAR V2 ─────────────────────────────────────────── -->

      <div
        class="min-h-screen flex flex-column relative flex-auto page-wrapper-v2"
        [class.content--expanded]="sidebarCollapsed"
        [style]="layoutService.paddingStyle">
        <header
          class="d-print-none header surface-card text-600 surface-border border-bottom-1 header-sticky"
          [hidden]="!showHeader"
          #header>
          <ng-container>
            <div class="container-fluid header-topbar">
              <!-- Botão abrir sidebar — visível apenas quando sidebar fechada -->
              @if (sidebarCollapsed) {
                <span
                  class="ps-1 me-3 cursor-pointer inline-flex align-items-center justify-content-center"
                  (click)="toggleSidebar('topbar-open-button')"
                  title="Abrir menu">
                  <patron-icon name="bi-list" size="lg"></patron-icon>
                </span>
              }

              <div class="header-title-shell">
                @if (!layoutService.headerTitleCustomTemplate) {
                  <h5 class="header-title mb-0 hidden sm:block">
                    {{ pageTitle$ | async }}
                  </h5>
                }

                @if (layoutService.headerTitleCustomTemplate) {
                  <div class="header-title-addon">
                    <ng-container
                      *ngTemplateOutlet="layoutService.headerTitleCustomTemplate"></ng-container>
                  </div>
                }
              </div>

              <nav class="header-nav ms-3 d-flex align-items-center gap-2">
                @if (layoutService.headerNavCustomTemplate) {
                  <div>
                    <ng-container
                      *ngTemplateOutlet="layoutService.headerNavCustomTemplate"></ng-container>
                  </div>
                }

                <!-- Customer Switcher -->
                @if (isCustomerUser && authCustomer) {
                  @if (hasMultipleCustomers) {
                    <div class="customer-switcher-dropdown">
                      <div
                        (click)="customerMenu.toggle($event)"
                        class="customer-display cursor-pointer">
                        <patron-icon name="bi-building" class="me-2 hidden md:inline"></patron-icon>
                        <span class="customer-name">{{
                          authCustomer.person?.name | truncate: [25]
                        }}</span>
                        <patron-icon name="bi-chevron-down" size="sm" class="ms-1"></patron-icon>
                      </div>
                      <p-popover
                        #customerMenu
                        appendTo="body"
                        z-index="1034"
                        (onShow)="dropdownVisibleChange('customerSwitch', true)"
                        (onHide)="dropdownVisibleChange('customerSwitch', false)"
                        styleClass="customer-overlay-panel">
                        <div class="px-3 py-2 border-bottom">
                          <h6 class="fw-semibold mb-1">Trocar Cliente</h6>
                          <small class="text-muted">Selecione o cliente para visualizar</small>
                        </div>
                        <div class="customer-list">
                          @for (customerAccess of availableCustomers; track customerAccess) {
                            <a
                              class="p-menuitem-link cursor-pointer d-block hover:bg-primary-50 text-decoration-none text-body"
                              (click)="switchCustomer(customerAccess); customerMenu.hide()"
                              [class.bg-primary-100]="
                                customerAccess.customer_id === authCustomer.id
                              ">
                              <span class="flex align-items-center w-full p-2">
                                <patron-icon name="bi-building" class="me-2"></patron-icon>
                                <span>{{
                                  customerAccess.customer?.person?.name | truncate: [35]
                                }}</span>
                                @if (customerAccess.customer_id === authCustomer.id) {
                                  <patron-icon
                                    name="bi-check-circle-fill"
                                    class="ms-auto text-success"></patron-icon>
                                }
                              </span>
                            </a>
                          }
                        </div>
                      </p-popover>
                    </div>
                  }
                  @if (!hasMultipleCustomers) {
                    <div class="customer-display-only">
                      <patron-icon name="bi-building" class="me-2 hidden md:inline"></patron-icon>
                      <span class="customer-name">
                        {{ authCustomer.person?.name | truncate: [25] }}
                      </span>
                    </div>
                  }
                }

                <patron-switch-theme></patron-switch-theme>

                <patron-cart-widget></patron-cart-widget>

                <ng-container *ngTemplateOutlet="notificationsDropdown"></ng-container>
                <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
              </nav>
            </div>
          </ng-container>

          <ng-template #notificationsDropdown>
            @if (coreConfig?.apiUrl && userHasAccessToNotifications) {
              <div class="relative">
                <patron-button
                  (onClick)="notificationsMenu.toggle($event)"
                  shape="circle"
                  iconName="bi-bell"
                  variant="outline">
                </patron-button>
                @if (notificationList?.unreadCountText?.length) {
                  <div class="absolute" style="top: -12px; right: -10px">
                    <patron-badge color="primary" size="sm">
                      {{ notificationList.unreadCountText.length }}
                    </patron-badge>
                  </div>
                }
              </div>
              <p-popover
                #notificationsMenu
                appendTo="body"
                z-index="1034"
                (onShow)="dropdownVisibleChange('notifications', true)"
                (onHide)="dropdownVisibleChange('notifications', false)"
                styleClass="notifications-overlay-panel">
                <div class="notifications-container p-0">
                  <patron-notification-list
                    #notificationList
                    [isFromHeader]="true"
                    [findOptions]="notificationsFindOptions"></patron-notification-list>
                  <div class="row justify-content-center mt-1">
                    <div class="col-auto">
                      <patron-button
                        variant="ghost"
                        (click)="goToNotificationsPage(); notificationsMenu.hide()"
                        >Ver mais</patron-button
                      >
                    </div>
                  </div>
                </div>
              </p-popover>
            }
          </ng-template>

          <ng-template #userDropdown>
            @if (user) {
              <div>
                <div (click)="userMenu.toggle($event)" class="cursor-pointer p-0">
                  <div class="relative">
                    <patron-avatar color="primary" textColor="white" size="md">
                      {{ getFirstLetter(user.name!) }}
                    </patron-avatar>
                    @if (currentAccessType) {
                      <div class="avatar-badge">
                        <patron-badge
                          [color]="patronUtils.getAccessTypeColor(currentAccessType.key)">
                          {{ getFirstLetter(currentAccessType.label) }}
                        </patron-badge>
                      </div>
                    }
                  </div>
                </div>
                <p-popover
                  #userMenu
                  appendTo="body"
                  z-index="1034"
                  (onShow)="dropdownVisibleChange('user', true)"
                  (onHide)="dropdownVisibleChange('user', false)"
                  styleClass="user-overlay-panel">
                  <div class="px-3 py-2 border-bottom">
                    <h6 class="fw-semibold mb-0">
                      {{ user.name! | truncate: [30] }}
                      <small>
                        @if (user.super_admin) {
                          <patron-badge color="primary" class="ml-1">super admin</patron-badge>
                        }
                      </small>
                    </h6>
                    @if (authCustomer?.person?.name) {
                      <div>Cliente: {{ authCustomer.person.name | truncate: [30] }}</div>
                    }
                    @if (authSupplier?.person?.name) {
                      <div>Fornecedor: {{ authSupplier.person.name | truncate: [30] }}</div>
                    }
                  </div>
                  <div class="user-menu-items">
                    @if (currentAccessType) {
                      <a
                        href="javascript:void(0)"
                        (click)="openAccessModal(); userMenu.hide()"
                        class="p-menuitem-link d-block cursor-pointer text-decoration-none hover:bg-primary-50 text-body">
                        <span class="flex align-items-center p-2">
                          <patron-icon class="me-2" name="bi-key"></patron-icon>
                          <patron-badge
                            class="me-1"
                            [color]="patronUtils.getAccessTypeColor(currentAccessType.key)"
                            >{{ currentAccessType.label }}</patron-badge
                          >
                          @if (companyGroup) {
                            <span>
                              {{ (companyGroup.name || companyGroup.alias)! | truncate: [30] }}
                            </span>
                          }
                        </span>
                      </a>
                    }
                    <a
                      [routerLink]="['perfil']"
                      (click)="userMenu.hide()"
                      class="p-menuitem-link d-block cursor-pointer text-decoration-none hover:bg-primary-50 text-body">
                      <span class="flex align-items-center p-2">
                        <patron-icon class="me-2" name="bi-person"></patron-icon> Meu perfil
                      </span>
                    </a>
                  <!-- @if (hasCompaniesPermission) {
                      <a
                        [routerLink]="['pessoas/empresas']"
                        (click)="userMenu.hide()"
                        class="p-menuitem-link d-block cursor-pointer text-decoration-none hover:bg-primary-50 text-body">
                        <span class="flex align-items-center p-2">
                          <patron-icon class="me-2" name="bi-buildings"></patron-icon> Minhas
                          empresas
                        </span>
                      </a>
                    }--> 
                    <a
                      [routerLink]="['alterar-senha']"
                      (click)="userMenu.hide()"
                      class="p-menuitem-link d-block cursor-pointer text-decoration-none hover:bg-primary-50 text-body">
                      <span class="flex align-items-center p-2">
                        <patron-icon class="me-2" name="bi-key"></patron-icon> Alterar senha
                      </span>
                    </a>
                    <a
                      href="javascript:void(0)"
                      (click)="logout(); userMenu.hide()"
                      class="p-menuitem-link d-block cursor-pointer text-decoration-none hover:bg-primary-50 text-body">
                      <span class="flex align-items-center p-2">
                        <patron-icon class="me-2" name="bi-box-arrow-right"></patron-icon> Sair
                      </span>
                    </a>
                  </div>
                </p-popover>
              </div>
            }
          </ng-template>
        </header>

        <div class="body flex-grow-1">
          @if (noLicenseInCurrentGroup) {
            <!-- Chamado #0000577675: controle de licenca ligado e o usuario sem licenca no grupo. -->
            <patron-alert color="warning" class="m-3">
              <strong>Você não possui licença neste grupo empresa.</strong>
              Fale com o administrador do sistema para liberar o seu acesso.
            </patron-alert>
          }
          <router-outlet>
            <patron-modal
              [visible]="notificationDetailsModalVisible"
              [title]="currentNotification?.title ?? 'Detalhes'"
              size="xl"
              (cancel)="notificationDetailsModalVisible = false"
              cancelButtonText="Fechar"
              id="notificationDetailsModal"
              #detailsModal
              [confirmButtonText]="currentNotification?.action ? 'Abrir' : ''"
              (confirm)="runNotificationAction()">
              @if (currentNotification?.message) {
                <quill-view-html [content]="currentNotification!.message!"></quill-view-html>
              }
            </patron-modal>
          </router-outlet>
        </div>

        <footer
          class="footer footer-fixed surface-card text-600 border-top-1 surface-border"
          id="footer">
          <div class="ms-auto">
            <app-ai-run-activity />
            @if (panelTitle) {
              <span> {{ panelTitle }}&nbsp; </span>
            }
            @if (config?.appVersion) {
              <span>
                @if (config?.repositorySlug) {
                  <span>
                    <a class="link" routerLink="/versoes">{{ config?.appVersion }}</a>
                  </span>
                }
                @if (!config?.repositorySlug) {
                  <span>
                    {{ config?.appVersion }}
                  </span>
                }
              </span>
            }
            @if (config?.env && config?.env != 'production') {
              <span>
                <span class="mx-2">|</span>
                <span class="hidden md:inline">Ambiente&nbsp;</span>
                <patron-badge color="info">
                  <span class="capitalize">{{
                    config?.env == 'homologation' ? 'Homologação' : config?.env
                  }}</span>
                </patron-badge>
              </span>
            }
            <span>
              <span class="mx-2">|</span>
              <span class="hidden md:inline">Desenvolvido por&nbsp;</span>
              <a class="link" href="https://www.teorema.inf.br" target="_blank">
                <span>Teorema</span>
              </a>
            </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</div>

<patron-toast></patron-toast>

<patron-modal
  title="Alterar senha"
  id="changePasswordConfirm"
  [visible]="changePasswordConfirmVisible"
  cancelButtonText="Agora não"
  (cancel)="onCancelChangePassword()"
  confirmButtonText="Alterar agora"
  confirmButtonColor="success"
  confirmButtonIcon="bi-key"
  (confirm)="goToChangePassword()">
  <patron-alert color="info">
    <p>Olá!</p>
    <p>
      Verificamos que você está utilizando uma senha padrão gerada pelo sistema, deseja alterar sua
      senha para acessar o painel futuramente?
    </p>
  </patron-alert>
</patron-modal>

<patron-modal
  title="Acesso"
  [visible]="accessModalVisible"
  (confirm)="accessModalVisible = false"
  confirmButtonText="Fechar">
  <p>
    @if (user) {
      <span>
        <strong>{{ user.name }}</strong> <br />
      </span>
    }

    Você esta acessando o sistema como <strong>{{ currentAccessType?.label }}</strong>
    @if (companyGroup) {
      <span>
        na empresa <strong>{{ companyGroup.name || companyGroup.alias }}</strong>
      </span>
    }
    <br />
    @if (authCustomer?.person?.name) {
      <span>
        {{ authCustomer.person.name }}
      </span>
    }
    @if (authSupplier?.person?.name) {
      <span>
        {{ authSupplier.person.name }}
      </span>
    }
  </p>

  <div style="padding-bottom: 15rem">
    <patron-select-company
      submitButtonText="Alterar"
      (onSubmit)="changeAccess()"></patron-select-company>
  </div>
</patron-modal>

@if (isOutdatedVersion) {
  <div class="info-alert">
    <patron-alert>
      <div class="flex align-items-center gap-2">
        <small class="mr-2"> Versão {{ updatedVersion }} disponível! </small>
        <patron-button size="sm" iconName="bi-arrow-clockwise" (click)="reloadPage()"
          >Atualizar</patron-button
        >
      </div>
    </patron-alert>
  </div>
}

@for (modal of modals; track modal; let i = $index) {
  <patron-modal #globalModalComponents></patron-modal>
}

@if (loadingTheme || layoutService.loadingModal) {
  <patron-overlay></patron-overlay>
}
